import { useEffect, useState } from "react";
import Image from "next/image";
import { useAppSelector } from "redux-share/hooks";
import { ConditionName, zIndex } from "interfaces";
import { changeVideoUrl, conditions, showLoaderTime } from "helpers";
import { handlePlayPause } from "redux-share/actions/controller.actions";
import IMAGES from "../../../../../images/importImages";
import { shallowEqual } from "react-redux";
import dynamic from "next/dynamic";

const Loader = dynamic(() => import("../../player-components/loader/loader"));
const BackwardForward = dynamic(() => import("../../player-components/backwardForward/backwardForward"));
const PlayPause = dynamic(() => import("../../player-components/playPause/playPause"));

const Main = () => {
    const [showLoader, setShowLoader] = useState<boolean>(false);
    const [showIcons, setShowIcons] = useState<boolean>(false);

    useAppSelector(({ controller: { lock, firstPlay } }) => ({ lock, firstPlay }), shallowEqual);
    const { isLoading, activeElements } = useAppSelector(
        ({ controller: { isLoading, activeElements } }) => ({ isLoading, activeElements }),
        shallowEqual
    );

    useEffect(() => {
        let timeout: any = null;
        if (conditions(ConditionName.isFirstPlay) || conditions(ConditionName.isActiveElements)) timeout = setTimeout(() => setShowIcons(true), 100);
        else setShowIcons(false);

        return () => clearTimeout(timeout);
    }, [activeElements]);

    useEffect(() => {
        let timeout: any;
        if (conditions(ConditionName.isLoading)) timeout = setTimeout(() => setShowLoader(true), showLoaderTime);
        else setShowLoader(false);
        return () => {
            clearTimeout(timeout);
            setShowLoader(false);
        };
    }, [isLoading]);

    return (
        <main className="pl-flex-1">
            {showLoader ? (
                <Loader />
            ) : (
                <>
                    {showIcons && !conditions(ConditionName.isLock) && (
                        <div
                            id="main-content"
                            className={`pl-h-full pl-flex pl-justify-center pl-items-center pl-text-center pl-relative ${
                                conditions(ConditionName.isActiveElements) ? "pl-pointer-events-auto" : "pl-pointer-events-none"
                            }`}
                        >
                            <div
                                className="pl-flex pl-justify-center pl-gap-6 pl-items-center pl-w-max"
                                style={{ zIndex: conditions(ConditionName.isComplexPortrait) ? zIndex.mainIconInComplexPortrait : zIndex.mainIcons }}
                            >
                                {conditions(ConditionName.isEnded) && conditions(ConditionName.isParamsPortrait) ? (
                                    <>
                                        {conditions(ConditionName.showBigReplayIcon) && (
                                            <>
                                                <Image
                                                    src={IMAGES.bigPlayNext}
                                                    width={32}
                                                    height={32}
                                                    onClick={() => (window.location.href = changeVideoUrl())}
                                                />
                                                <Image
                                                    src={IMAGES.bigReplay}
                                                    onClick={(event: any) => !conditions(ConditionName.isLiveParam) && handlePlayPause(event)}
                                                    width={56}
                                                    height={56}
                                                    className={conditions(ConditionName.isLiveParam) ? "pl-opacity-50" : ""}
                                                />
                                                <Image src={IMAGES.bigPlayPrevious} width={32} height={32} className="pl-opacity-50" />
                                            </>
                                        )}
                                    </>
                                ) : (
                                    <>
                                        {!conditions(ConditionName.isFirstPlay) && <BackwardForward type="forward" />}
                                        <PlayPause />
                                        {!conditions(ConditionName.isFirstPlay) && <BackwardForward type="backward" />}
                                    </>
                                )}
                            </div>
                        </div>
                    )}
                </>
            )}
        </main>
    );
};

export default Main;
